import { graphql } from "@opensea/graphql"
import { CreateOrdersSummaryFragment } from "../../../../../components/CreateOrdersSummary/CreateOrdersSummary.fragment"
import { CreateCollectionOfferFlowTableFragment } from "../CollectionOfferFlowTable/CreateCollectionOfferFlowTable.fragment"
import { CreateCollectionOfferTraitInputFragment } from "../CreateCollectionOfferTraitInput/CreateCollectionOfferTraitInput.fragment"

export const CreateCollectionOfferFormFragment = graphql(
  `
    fragment CreateCollectionOfferForm on Collection {
      ...CreateCollectionOfferFlowTable
      ...CreateCollectionOfferTraitInput
      ...CreateOrdersSummary
      traitOffersEnabled
      chain {
        identifier
        nativeCurrency {
          address
        }
        offerCurrency {
          address
          symbol
        }
      }
    }
  `,
  [
    CreateCollectionOfferFlowTableFragment,
    CreateCollectionOfferTraitInputFragment,
    CreateOrdersSummaryFragment,
  ],
)
